import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

import { initAppActions } from './Managers/AppActions'

initAppActions()

const root = createRoot(document.getElementById('root'))

root.render(<App />)
